export default __webpack_public_path__ + "static/media/covid_life.bb017906.jpg";